import React, { useEffect, useRef, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import OtpInput from 'react-otp-input';
import './styles.scss';

// @ts-ignore
const OtpModal = ({
  handleClose,
  show,
  title,
  subtitle = '',
  onSuccess,
  resend,
  txtError = '',
  txtSuscces = '',
  autoFillOTP = null,
  loading = false,
  isVerified = false,
}) => {
  const otpRef = useRef(null);
  const showHideClassName = show
    ? 'fixed hidden inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full modal display-block'
    : 'modal display-none';
  const [otp, setOtp] = useState<any>();
  const [resendStatus, setResend] = useState<boolean>(false);
  const [canVerfy, setCanVerfy] = useState<any>(false);
  const [newError, setNewError] = useState<any>('');
  // const [isLoading, setLoading] = React.useState(false);

  const handleChange = (data: any) => {
    setOtp(data);
    if (data.length === 6) {
      setCanVerfy(true);
      // setLoading(true);
      onSuccess(data);
      setNewError(txtError);
    } else {
      setCanVerfy(false);
    }
  };

  useEffect(() => {
    if (otp?.length === 0) otpRef.current.focusInput(0);
  }, [otp]);

  const onHide = () => {
    // setLoading(false);
    setOtp('');
    setCanVerfy(false);
    handleClose();
  };

  const [minutes, setMinutes] = useState(2);
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    if (resendStatus) {
      const myInterval = setInterval(() => {
        if (seconds > 0) {
          setSeconds(seconds - 1);
        }
        if (seconds === 0) {
          if (minutes === 0) {
            clearInterval(myInterval);
            setResend(false);
          } else {
            setMinutes(minutes - 1);
            setSeconds(59);
          }
        }
      }, 1000);
      return () => {
        clearInterval(myInterval);
      };
    }
  }, [resendStatus, seconds]);

  useEffect(() => {
    if (autoFillOTP) {
      setCanVerfy(true);
      setOtp(autoFillOTP);
    }
  }, [autoFillOTP]);

  useEffect(() => {
    if (txtError || txtSuscces) {
      setOtp('');
      setNewError('');
    }
    setResend(false);
  }, [txtError, txtSuscces, newError]);

  useEffect(() => {
    return () => {
      // setLoading(false);
      // console.log('Cleared OTP field');
      setOtp('');
      setCanVerfy(false);
    };
  }, []);

  return (
    <Modal
      show={show}
      onHide={onHide}
      backdrop='static'
      keyboard={false}
      aria-labelledby='contained-modal-title-vcenter'
      centered
    >
      <Modal.Body>
        <div className='text-center'>
          <h4>{title}</h4>
          <p>{subtitle}</p>
        </div>
        <div className='row justify-content-md-center'>
          <div className='w-full'>
            <form className='bg-white rounded pt-6 pb-8 mb-4'>
              <div className='row justify-content-md-center'>
                <OtpInput
                  ref={otpRef}
                  inputStyle={{
                    width: '2.7rem',
                    height: '2.7rem',
                    margin: '10px 0.4rem',
                    fontSize: '20px',
                    borderRadius: 4,
                    border: '2px solid rgba(0,0,0,0.3)',
                  }}
                  containerStyle={{ justifyContent: 'center' }}
                  value={autoFillOTP ? autoFillOTP : otp}
                  onChange={handleChange}
                  isInputNum
                  isInputSecure
                  numInputs={6}
                  shouldAutoFocus
                />
              </div>
              <div
                className='mx-5 px-2 row justify-content-md-center mb-2'
                style={{ fontSize: '12px' }}
              >
                <div className='px-3'>
                  <a
                    className={`mt-1 outline-none focus:outline-none text-red-400 ${
                      resendStatus ? 'isDisabled' : ''
                    }`}
                    type='button'
                    style={{ fontSize: '12px', cursor: 'pointer' }}
                    onClick={() => {
                      setResend(true);
                      resend();
                    }}
                  >
                    Resend OTP
                  </a>
                  {!resendStatus ? null : (
                    <h5 className='float-end'>
                      {' '}
                      {minutes}:{seconds < 10 ? `0${seconds}` : seconds}
                    </h5>
                  )}
                </div>
              </div>
              <div
                className='row mb-2 text-center'
                style={{ fontSize: '14px' }}
              >
                <span className='text-success'>{txtSuscces}</span>
              </div>
              <div
                className='row mb-2 text-center error'
                style={{ fontSize: '14px' }}
              >
                <span className='text-danger'>{txtError}</span>
              </div>
            </form>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={onHide}>
          Close
        </Button>
        {!isVerified && (
          <Button
            // style={{ width: '15%' }}
            disabled={!canVerfy || loading}
            variant='primary'
            onClick={() => {
              onSuccess(otp);
              setTimeout(() => {}, 1500);
            }}
          >
            {!loading ? (
              'Verify'
            ) : (
              <div className='spinner-border text-white' role='status'>
                <span className='visually-hidden'>Loading...</span>
              </div>
            )}
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default OtpModal;